var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99473 6.10352e-05C7.6899 6.10085e-05 7.43469 0.255267 7.43469 0.553007L7.43469 7.83347L7.47723 8.88974L6.99517 8.38641L5.92472 7.24508C5.82548 7.13165 5.67661 7.07494 5.54192 7.07494C5.24417 7.07494 5.02441 7.28761 5.02441 7.57117C5.02441 7.72713 5.08113 7.84056 5.18746 7.94689L7.58356 10.2579C7.72534 10.3997 7.85295 10.4493 7.99473 10.4493C8.1436 10.4493 8.26411 10.3997 8.40589 10.2579L10.802 7.94689C10.9083 7.84056 10.9721 7.72713 10.9721 7.57117C10.9721 7.28761 10.7595 7.07494 10.4617 7.07494C10.3199 7.07494 10.1711 7.13165 10.0718 7.24508L8.51223 8.89683L8.56185 7.83347L8.56185 0.553007C8.56185 0.255267 8.29956 6.10618e-05 7.99473 6.10352e-05ZM3.93299 16C2.45847 16 1.70703 15.2698 1.70703 13.8024L1.70703 6.8126C1.70703 5.34516 2.45847 4.61499 3.93299 4.61499L5.91084 4.61499V5.75633L3.95426 5.75633C3.24536 5.75633 2.84837 6.13205 2.84837 6.86931L2.84837 13.7457C2.84837 14.483 3.24536 14.8587 3.95426 14.8587L12.05 14.8587C12.7447 14.8587 13.1488 14.483 13.1488 13.7457L13.1488 6.86931C13.1488 6.13205 12.7447 5.75633 12.05 5.75633H10.0934V4.61499H12.0641C13.5528 4.61499 14.2901 5.35225 14.2901 6.8126L14.2901 13.8024C14.2901 15.2628 13.5528 16 12.0641 16H3.93299Z",
    fill: "#414141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.5fedc9048c9e518eb2db0a6b258b9cd3.svg";
export { ForwardRef as ReactComponent };